import { useProfile } from "../../authentication/state/profile";

import AccountSettingsView from "../views/AccountSettingsView/AccountSettingsView";

export default function AccountSettings() {
	const profile = useProfile();

	return <AccountSettingsView user={profile} />;
}
